/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint max-len: ["error", { "code": 1000 }] */
/* eslint-disable no-await-in-loop */
// import clients from '../__mocks__/clients';
import { apiGranel as api } from './utils/api';

import formatGranelSimulation from './utils/formatGranelSimulation';

export const getParameterByCod = async (cod) => {
  const res = await api.get(`/api/Parameter/${cod}`);
  return res.data;
};

export const getClients = async (code, withDelegation = true, globalAccess = false, search = '') => {
  if (!code && !globalAccess) { return []; }

  const sellerCode = (!globalAccess ? code : null);

  const res = await api.get('/api/Customer', {
    params: {
      take: 0, sellerCode, withDelegation, search,
    },
  }).then((response) => response.data);

  return res;
};

export const getClientByCod = async (codCliente) => {
  let res = [];
  if (codCliente !== null) {
    res = await api.get(`/api/Customer/${codCliente}/CustomerCode`);
  }

  return res;
};

export const postClient = async (clienteFields) => clienteFields;

export const getFabricaById = async (id) => {
  let res = {};
  if (id !== null) {
    res = await api.get(`/api/Factory/${id}`, { params: { withAddress: true } });
  }

  return res;
};

export const getFabricasVC = async () => {
  const res = await api.get('/api/Factory', { params: { onlyHasMaterial: true, companyType: 1, take: 0 } });

  return res;
};

export const getSegments = async () => {
  const res = await api.get('/api/Segment', { params: { take: 0 } }).then((response) => response.data);

  return res;
};

export const getReasons = async () => {
  const res = await api.get('/api/Reason').then((response) => response.data);

  return res;
};

export const postFabricaVC = async (fabricaVCFields) => fabricaVCFields;

export const getCompaniasConcorrente = async () => {
  const res = await api.get('/api/Company', {
    params: { take: 0, field: 'type', value: 'Concorrente' },
  });

  return res;
};

export const getMapMineReference = async (params) => {
  const res = await api.get('/api/MapMine/Reference', { params: { ...params } });
  return res;
};

export const getKaMasterReference = async (params) => {
  const res = await api.get('/api/KAMasterPrices/Reference', { params: { ...params } });
  return res;
};

export const getSugestedFreight = async (distance) => {
  const res = await api.get(`/api/TKUs/CalculateTkuFreight/${distance}`);
  return res;
};

export const getFabricasConcorrente = async (companyId) => {
  let res = [];
  if (companyId !== null && companyId !== '') {
    res = await api.get(`/api/Factory/${companyId}/Company`, { params: { onlyHasMaterial: true } });
  }

  return res;
};

export const getProdutosFabrica = async (fabricaId) => {
  let res = [];
  if (fabricaId !== null && fabricaId !== '') {
    res = await api.get(`/api/FactoryMaterial/${fabricaId}/Factory`);
  }

  return res;
};

export const postFabricaConcorrente = async (fabricaConcorrenteFields) => fabricaConcorrenteFields;

export const getCiconsRange = async (factoryMaterialId, type, range) => {
  let res = [];
  if (factoryMaterialId !== null && factoryMaterialId !== '' && range !== null) {
    res = await api.get(`/api/Cicon/DateRange/${factoryMaterialId}`, {
      params: { from: range.from, to: range.to, type },
    });
  }

  return res;
};

export const getCiconsLatest = async (factoryMaterialId, type) => {
  let res = [];
  if (factoryMaterialId !== null && factoryMaterialId !== '') {
    res = await api.get(`/api/Cicon/Latest/${factoryMaterialId}`, {
      params: { quantity: 6, type: type || 2 },
    });
  }

  return res?.data?.reverse();
};

export const getCiconsAverage = async (factoryMaterialId, cicons, type) => {
  let res = [];
  if (factoryMaterialId !== null && factoryMaterialId !== '' && cicons !== null) {
    const ciconType = type !== '' ? type : null;
    res = await api.post(`/api/Cicon/Average/${factoryMaterialId}`, cicons, { params: { ciconType } });
  }

  return res;
};

export const getCiconsStandardDeviation = async (factoryMaterialId, cicons, type) => {
  let res = [];
  if (factoryMaterialId !== null && factoryMaterialId !== '' && cicons !== null) {
    const ciconType = type !== '' ? type : null;
    res = await api.post(`/api/Cicon/StandardDeviation/${factoryMaterialId}`, cicons, { params: { ciconType } });
  }

  return res;
};

export const getCiconsPercentage = async (fields) => {
  let res = [];
  if (fields !== null) {
    res = await api.post('/api/Cicon/GetPercentage/', fields);
  }

  return res;
};

export const getSpecialDiscount = async (factoryMaterialVcId, factoryMaterialCompetitorId, microregionId) => {
  const res = await api.get(`/api/SpecialDiscount/FactoryMaterial/${factoryMaterialVcId}/${factoryMaterialCompetitorId}`, { params: { microregionId } });

  return res;
};

export const getValidateDates = async () => {
  const res = await api.get('/api/ValidateDate/', { params: { take: 0 } });

  return res;
};

export const getDeadlines = async () => {
  const res = await api.get('/api/Deadline/', { params: { take: 0 } });

  return res;
};

export const calculate = async (fields) => {
  const formatedFields = formatGranelSimulation(fields);

  const menorvc = Math.max.apply(null, fields.cicons.ciconsVC.map((cicon) => cicon.value).filter((cicon) => cicon > 0));
  const maiorconc = Math.min.apply(null, fields.cicons.ciconsCompetitor.map((cicon) => cicon.value).filter((cicon) => cicon > 0));

  const formatedCicon = {
    CiconPercentage: (fields.cicons.ciconPercentage || 0),
    AverageVC: fields.cicons.averageVC,
    StandardDeviationVc: fields.cicons.standardDeviationVC,
    AverageComp: fields.cicons.averageCompetitor,
    StandardDeviationComp: fields.cicons.standardDeviationCompetitor,
    BiggestCompetitor: maiorconc,
    LowestVC: menorvc,
  };

  const res = await api.post('/api/ResultSimulation/CalculateResults/', formatedFields, { params: formatedCicon });

  return res;
};

export const postProposta = async (fields) => {
  const formatedFields = formatGranelSimulation(fields);

  let res = {};
  if (formatedFields.Id) {
    res = await api.put('/api/Simulation/', formatedFields);
  } else {
    res = await api.post('/api/Simulation/', formatedFields);
  }

  return res;
};

export const postResultado = async (fields) => {
  const { resultadosCif, resultadosFob, resultados } = fields;
  const formatedFields = {
    ResultSimulationCif: {
      SimulationId: resultados.simulationId,
      Regra: resultadosCif.regra,
      SugCicon: resultadosCif.sugCicon,
      SugestionHomogation: resultadosCif.sugestionHomogation,
      MinimalPrice: resultadosCif.minimalPrice,
      MinPrice: resultadosCif.minimalPrice,
      SugNegPercent: resultadosCif.sugNegPercent,
      DescRegraPercent: resultadosCif.descRegraPercent,
      ApprovalHierarchy: resultadosCif.approvalHierarchy,
    },
    ResultSimulationFob: {
      SimulationId: resultados.simulationId,
      Regra: resultadosFob.regra,
      SugCicon: resultadosFob.sugCicon,
      SugestionHomogation: resultadosFob.sugestionHomogation,
      MinimalPrice: resultadosFob.minimalPrice,
      MinPrice: resultadosFob.minimalPrice,
      SugNegPercent: resultadosFob.sugNegPercent,
      DescRegraPercent: resultadosFob.descRegraPercent,
      ApprovalHierarchy: resultadosFob.approvalHierarchy,
    },
  };

  const res = await api.post('/api/ResultSimulation/', formatedFields);

  return res;
};

export const sendApprovals = async ({ user, incoterm, fields }) => {
  const res = await api.post(
    `/api/ProposalSAP/SendApproval/${fields.resultados.simulationId}`,
    {
      UserCode: user?.employeeId,
      ConditionTypeCode: fields.shortCondition,
      Condition: fields.condition,
      ShortText: fields.shortText || fields.shortCondition,
      LongText: `Enviado via Simulador \n ${fields.justificativa} \n ${fields.justificativaFixa}`,
      Incoterms: incoterm === 1 ? 'CIF' : 'FOB',
      Deadline: fields.deadline,
      ValidityStartDate: fields.startDate,
      ValidityEndDate: fields.endDate,
    },
  );

  return res;
};

export const sendEmail = async (fields) => {
  const formatedFields = {
    ToEmail: fields.emailTo || '',
    Subject: fields.subject,
    Body: `${fields.body}`,
  };

  let res = { data: null, isSuccess: false };
  if (fields.emails && fields.emails !== undefined && Array.isArray(fields.emails)) {
    for (let i = 0; i < fields.emails.length; i += 1) {
      formatedFields.ToEmail = fields.emails[i];

      res = await api.post('/api/email/send', formatedFields, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
  } else {
    res = await api.post('/api/email/send', formatedFields, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  const resProposal = await api.post(`/api/Simulation/SendEmail/${fields.id}`);

  return res;
};

export const getSimulations = async (accountId, sellerCode = null, s = null, skip = 0, take = 10, filters = {}) => {
  const params = {
    skip, take, accountId, sellerCode, cleanLoad: true, ...filters,
  };
  if (s && s !== '' && s !== null) {
    params.field = s?.field;
    params.value = s?.value;
  }

  const res = await api.get('/api/Simulation/', { params });

  return res;
};

export const getSimulation = async (simulationId) => {
  let res = {};
  if (simulationId && simulationId !== null) {
    res = await api.get(`/api/Simulation/${simulationId}`);
  }

  return res;
};

// Employee
export const getEmployee = async (formData) => {
  const res = await api.post('/api/Employee/', formData);

  return res;
};

export const getVendedores = async (email) => {
  const res = await api.get('/api/Seller', {
    params: {
      take: 0,
      // office: 1,
      // email,
      // withDelegation: false,
    },
  }).then((response) => response.data);

  return res;
};

export const getDelegations = async (sellerOriginCode, sellerDelegationCode) => {
  if (!sellerOriginCode || !sellerDelegationCode) {
    return [];
  }

  const res = await api.get(`/api/Delegation/${sellerOriginCode}/${sellerDelegationCode}`).then((response) => response.data);
  return res;
};

export const sendDelegation = async (delegationFields) => {
  const res = await api.post('/api/Delegation', delegationFields).then((response) => response.data);
  return res;
};

export const sendDelegationMassive = async (delegationFields) => {
  const res = await api.post('/api/Delegation/Massive', delegationFields).then((response) => response.data);
  return res;
};

export const deleteDelegation = async (id) => {
  const res = await api.delete(`/api/Delegation/${id}`).then((response) => response);
  return res;
};

export const deleteDelegationMassive = async (ids) => {
  const res = await api.post('/api/Delegation/Massive/Delete', ids).then((response) => response);
  return res;
};

export const getVendedorEmail = async (email) => {
  const res = await api.get('/api/Seller/Email', { params: { email } }).then((response) => response.data);
  return res;
};

export const getVendedorByCode = async (code) => {
  if (!code) {
    return false;
  }
  const res = await api.get(`/api/Seller/${code}/SellerCode`).then((response) => response.data);
  return res;
};

export const getCoordenadorByCode = async (code) => {
  if (!code) {
    return false;
  }
  const res = await api.get(`/api/Coordinator/${code}/CoordinatorCode`).then((response) => response.data);
  return res;
};

export const getStatusApproval = async (NUM_EXTERNO) => {
  const res = await api.get(`/api/ProposalSAP/ConsultApproval/${NUM_EXTERNO}`).then((response) => response?.data || response);

  return JSON.parse(res);
};
